import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
//import WatchMeItem from './WatchMeItem';
import Loading from '../common/Loading';
import VideoItem from '../common/VideoItem';
import ErrorMessage from '../common/ErrorMessage';

class WatchMe extends React.Component {
    constructor(props, context) {
        super(props, context);
     }

    componentDidMount() {  
        if((!this.props.artist.Videos && !this.props.artist.VideosStatus) || this.props.artist.VideosStatus === 'FAILED') {
            this.props.actions.getVideos(this.props.artist.Username);
        }
    }

    render() {
        const artist = this.props.artist;
        const actions = this.props.actions;
        return (
            artist.VideosStatus === 'FAILED' ?
                <ErrorMessage error="Sorry, something went wrong! Unable to load videos." />
                :
                <div className="videos">                    
                    {artist.Videos && artist.Videos.length > 0 ?
                        <ul id="ulHearMe" className="list-unstyled itemlist hearlist">
                        {artist.Videos.map((video) => <VideoItem key={video.ID} video={video} actions={actions} showVideoName showArtistName={artist.RoleType === 'Fan'} />)}
                        </ul>
                    : (artist.VideosStatus === 'LOADING' ?
                    <Loading /> : <p className="biotext">Coming soon...</p>)}
                </div>
        );
    }
}

WatchMe.propTypes = {
    artist: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired
};

export default WatchMe;